import { getMetricsSuffix } from 'app/config/metrics.config.helper';
import { type ConfigContextState } from 'app/common/ConfigContext';
import { getBackendUrl } from 'app/utils/api_url';

const getSeriesMatchesFetchUrl = (
  seriesId: number,
  matchStatus: 'finished' | 'upcoming',
  pageNumber: number,
  pageSize: number,
  config: ConfigContextState
) =>
  `${getBackendUrl()}/api/series/${seriesId}/matches/${matchStatus}${getMetricsSuffix(
    config
  )}&page[number]=${pageNumber + 1}&page[size]=${pageSize}`;

export { getSeriesMatchesFetchUrl };
